import React, { useState, useRef, useEffect } from 'react';
import Filters from '../../components/Filters/filterbyDashboard';
import DashboardChart from '../../components/Chart/DashboardChart';
import DashboardHeader from './dashboardHeader';
import { generateChartData } from '../../components/Chart/config/chartConfig';
import styles from './Index.module.css';
import { Dropdown } from 'primereact/dropdown';
import { useTranslation } from 'react-i18next';

const Dashboard: React.FC = (): JSX.Element => {
    const [chartData, setChartData] = useState<any[]>([]);
    const filtersRef = useRef<{ handleFilterClick: () => Promise<void> }>(null);
    const [selectedTime, setSelectedTime] = useState<number | null>(null);
    const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null);
    const [loading, setLoading] = useState<boolean>(false); 
    const { t: translateDash } = useTranslation("dashboard");
    const [dateFilter, setDateFilter] = useState<any>(new Date());

    const timeOptions = [
        { label: translateDash("disabled"), value: 0 },
        { label: translateDash("1minute"), value: 60000 },
        { label: translateDash("5minutes"), value: 300000 },
        { label: translateDash("10minutes"), value: 600000 },
    ];

    const { chartData: generatedChartData, totalCount, cumulativeOK, cumulativeNOk, averageAccuracy, deviceId } = generateChartData(chartData);

    const loadChartData = async (): Promise<void> => {
        if (filtersRef.current) {
            setLoading(true);
            await filtersRef.current.handleFilterClick();
            setLoading(false);
        }
    };
    
    useEffect(() => {
        const storedTime = localStorage.getItem('selectedTime');
        if (storedTime) {
            const parsedTime = JSON.parse(storedTime);
            setSelectedTime(parsedTime);
        }
    }, []);
    
    useEffect(() => {
        // Chama a função para carregar os dados no carregamento inicial ou quando o dropdown muda
        loadChartData(); 
    
        // Configura o intervalo se o tempo selecionado for maior que 0
        if (selectedTime && selectedTime > 0) { 
            const newIntervalId = setInterval(() => {
                loadChartData();
            }, selectedTime);
            setIntervalId(newIntervalId);
    
            // Limpa o intervalo ao desmontar o componente ou ao mudar a seleção
            //return () => clearInterval(newIntervalId);
        }
    }, [selectedTime]);
    

    const handleTimeChange = (e: { value: number | null }): void => {
        setSelectedTime(e.value);
        localStorage.setItem('selectedTime', JSON.stringify(e.value)); // Armazena a seleção no localStorage

        // Se o novo tempo for 0, limpa o intervalo
        if (e.value === 0 && intervalId) {
            clearInterval(intervalId);
            setIntervalId(null);
        }
    };

    return (
        <div className={styles.container}>
              <div className={styles.dropdownContainer}>
                <span className={styles.label}>{`${translateDash("rechargeOn")}:`}</span>
                <Dropdown
                    value={selectedTime}
                    options={timeOptions}
                    onChange={handleTimeChange}
                    placeholder={translateDash("selectInterval")}
                    style={{
                        border: '0px solid #ccc',
                        backgroundColor: '#fff',
                        color: '#333',
                        boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
                        marginTop: '10px'
                    }}
                    
                />
            </div>
            <Filters ref={filtersRef} setChartData={setChartData} className={styles.filtersContainer} setDateFilter={setDateFilter} /> 
           
       
            {loading ? ( 
                <div className={styles.loading}>
                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                </div>
            ) : (
                <DashboardHeader 
                    totalCount={totalCount} 
                    cumulativeOK={cumulativeOK} 
                    cumulativeNOk={cumulativeNOk} 
                    averageAccuracy={averageAccuracy}
                />
            )}
            <DashboardChart chartData={generatedChartData} deviceId={deviceId} events={[]} dateFilter={dateFilter}/>
        </div>
    );
};

export default Dashboard;
